import AnswerPopup from "./Components/AnswerPopup/AnswerPopup";
import Comments from "./Components/Comments/Comments";
import ExitCasePopup from "./Components/ExitCasePopup/ExitCasePopup";
import HelpPopup from "./Components/HelpPopup/HelpPopup";
import LabPanels from "./Components/LabPanels/LabPanels";
import SimulationBody from "./Components/SimulationBody/SimulationBody";
import SimulationFooter from "./Components/SimulationFooter/SimulationFooter";
import SimulationHeader from "./Components/SimulationHeader/SimulationHeader";
import SettingsPanel from "./Components/SettingsPanel/SettingsPanel";

import AnswerPopupCDMQB from "./Components/AnswerPopup/Answerpopupcdmqb";
import CommentsCDMQB from "./Components/Comments/Commentscdmqb";
import ExitCasePopupCDMQB from "./Components/ExitCasePopup/Exitcasepopupcdmqb";
import EndOfPartPopupCDMQB from "./Components/EndOfPartPopup/Endofpartpopupcdmqb";
import HelpPopupCDMQB from "./Components/HelpPopup/Helppopupcdmqb";
import LabPanelsCDMQB from "./Components/LabPanels/Labpanelscdmqb";
import InstructionsCDMQB from "./Components/Instructions/Instructionscdmqb";
import SimulationBodyCDMQB from "./Components/SimulationBody/Simulationbodycdmqb";
import SimulationFooterCDMQB from "./Components/SimulationFooter/Simulationfootercdmqb";
import SimulationHeaderCDMQB from "./Components/SimulationHeader/Simulationheadercdmqb";
import SimulationCalculatorCDMQB from "./Components/Calculator/Simulationcalculatorcdmqb";
import SettingsPanelCDMQB from "./Components/SettingsPanel/Settingspanelcdmqb";
import CharacterWarningCDMQB from "./Components/CharacterPopupWarning/CharacterPopupWarningcdmqb";
import FeedbackPopupCDMQB from "./Components/FeedbackPopup/Feedbackpopupcdmqb";
import { CDMQB_SKIN_ID } from "./SimulationConstants";
import FeedbackPopup from "./Components/FeedbackPopup/Feedbackpopup";

const DEFAULT_SKIN_BUNDLE = {
  Header: SimulationHeader,
  Body: SimulationBody,
  Footer: SimulationFooter,
  LabPanels,
  Comments,
  AnswerPopup,
  ExitCasePopup,
  HelpPopup,
  // The default skin has no calculator.
  Calculator: null,
  // The default skin has no instructions modal.
  Instructions: null,
  // The default skin has no End of Part confirmation (its footer shows an
  // OK button in the submit step instead).
  EndOfPartPopup: null,
  // Text size / font / skin switcher (no CDMQB-only options).
  SettingsPanel,
  CharacterWarning: null,
  // The default skin has no toolbar Feedback popup.
  FeedbackPopup: FeedbackPopup,
};

const CDMQB_SKIN_BUNDLE = {
  Header: SimulationHeaderCDMQB,
  Body: SimulationBodyCDMQB,
  Footer: SimulationFooterCDMQB,
  LabPanels: LabPanelsCDMQB,
  Comments: CommentsCDMQB,
  AnswerPopup: AnswerPopupCDMQB,
  ExitCasePopup: ExitCasePopupCDMQB,
  HelpPopup: HelpPopupCDMQB,
  Calculator: SimulationCalculatorCDMQB,
  Instructions: InstructionsCDMQB,
  EndOfPartPopup: EndOfPartPopupCDMQB,
  SettingsPanel: SettingsPanelCDMQB,
  CharacterWarning: CharacterWarningCDMQB,
  FeedbackPopup: FeedbackPopupCDMQB,
};

export const SIMULATION_SKIN_BUNDLES = {
  default: DEFAULT_SKIN_BUNDLE,
  [CDMQB_SKIN_ID]: CDMQB_SKIN_BUNDLE,
};

export const DEFAULT_SIMULATION_SKIN = "default";

export const getSimulationSkinComponents = (skinId) => {
  const overrides = SIMULATION_SKIN_BUNDLES[skinId] || {};
  return { ...DEFAULT_SKIN_BUNDLE, ...overrides };
};
